"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

var _utils = require("../utils");

var _hooks = require("../hooks");

var _header = require("./header");

var _footer = require("./footer");

var _layoutModule = _interopRequireDefault(require("./layout.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Layout = function Layout(_ref) {
  var children = _ref.children,
      pageContext = _ref.pageContext;

  var _useTheme = (0, _hooks.useTheme)(),
      theme = _useTheme.theme;

  var path = (0, _utils.getProperty)(pageContext, "data.path");

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hideHeader = _useState2[0],
      setHideHeader = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showMenu = _useState4[0],
      setShowMenu = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFixed = _useState6[0],
      setIsFixed = _useState6[1];

  var _useScroll = (0, _hooks.useScroll)(),
      scrollY = _useScroll.scrollY,
      isScrollingDown = _useScroll.isScrollingDown;

  var isEscapePressed = (0, _hooks.useKeyPress)("Escape");
  var hasScrolled = (0, _react.useMemo)(function () {
    return scrollY > 0;
  }, [scrollY]);
  var wrapperClassName = (0, _react.useMemo)(function () {
    return [_layoutModule.default.wrapper, _layoutModule.default[theme]].join(" ");
  }, [theme]);
  var toggleHandler = (0, _react.useCallback)(function () {
    return setShowMenu(!showMenu);
  }, [showMenu]);
  (0, _react.useEffect)(function () {
    setHideHeader(isScrollingDown);
  }, [isScrollingDown]);
  (0, _react.useEffect)(function () {
    setIsFixed(hasScrolled);
  }, [hasScrolled]);
  (0, _react.useEffect)(function () {
    if (isEscapePressed) {
      setShowMenu(false);
    }
  }, [isEscapePressed]);
  (0, _react.useEffect)(function () {
    setShowMenu(false);
  }, [path]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
    htmlAttributes: {
      class: _layoutModule.default[theme]
    }
  }), /*#__PURE__*/_react.default.createElement(_header.Header, {
    isFixed: isFixed,
    onToggle: toggleHandler,
    showMenu: showMenu,
    isHidden: hideHeader
  }), /*#__PURE__*/_react.default.createElement("main", {
    className: _layoutModule.default.main
  }, children), /*#__PURE__*/_react.default.createElement(_footer.Footer, null));
};

exports.Layout = Layout;
Layout.defaultProps = {
  pageContext: {}
};
Layout.propTypes = {
  pageContext: _propTypes.default.shape({
    data: _propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      path: _propTypes.default.string.isRequired
    }).isRequired,
    locale: _propTypes.default.string.isRequired
  }).isRequired
};